<template>
  <div>
    <div v-for="(item, index) in borrowerDetails" :key="index" class="accordion" role="tablist">
      <div no-body class="my-1 p-1 bg-white">
      <b-card-header header-tag="header" class="p-1 border" role="tab">
      <b-row
        align-v="center"
        class="py-1">
        <b-col :id="`${index}B`" v-b-toggle="index + 'borrower'" class="d-flex" md="11"
               @click="item.isVisibleBorrower = !item.isVisibleBorrower">
          <b-col md="2">
          <div>
            <BaseELabel :label="`Borrower ${index + 1} Information`" />
          </div>
        </b-col>
        <b-col md="auto"> <b-badge v-if="showName(item)"
        variant="secondary">{{ `${item.firstName} ${item.middleName} ${item.lastName}` }}</b-badge></b-col>
        <b-col md="3"> <b-badge v-if="item.ssn" variant="info"> {{ item.ssn }}</b-badge> </b-col>
        <strong class="ml-auto pt-1"><i :class="`fa fa-angle-${item.isVisibleBorrower ? 'up' : 'down'}`"></i></strong>
        </b-col>
        <b-col md="1" class="text-left pl-0">
          <BaseIcon
          v-if="index"
          v-b-tooltip.hover.top="`Remove Borrower ${index + 1}`"
          noninteractive
          name="times-circle"
          class="cursor-pointer"
          @click="onRemoveBorrower(index)"
        />
        </b-col>
      </b-row>
      </b-card-header>
    <b-collapse :id="`${index}` + 'borrower'"
                visible :accordion="`${index}` + 'borrower'" role="tabpanel"
                class="border">
    <b-row class="px-4 pt-3">
      <b-col md="3">
        <BaseEInputText
          :value="item.firstName"
          :validattor="Validattor.specialName"
          data-vv-as="First Name"
          type="text"
          :name="index + 'firstName'"
          maxlength="50"
          label-content="First Name"
          mark-required
          :placeholder="placeholders.firstName"
          @blur="(v) => (item.firstName = tfCustomValidation({ 'First Name': v.target.value }, index, 'required | specialName'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'First Name', 'required') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="item.middleName"
          :validattor="Validattor.specialName"
          data-vv-as="Middle Name"
          type="text"
          :name="index + 'middleName'"
          maxlength="50"
          label-content="Middle Name"
          :placeholder="placeholders.middleName"
          @blur="(v) => (item.middleName = tfCustomValidation({ 'Middle Name': v.target.value }, index, 'specialName'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'Middle Name') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="item.lastName"
          :validattor="Validattor.specialName"
          data-vv-as="Last Name"
          type="text"
          :name="index + 'lastName'"
          maxlength="20"
          label-content="Last Name"
          mark-required
          :placeholder="placeholders.lastName"
          @blur="(v) => (item.lastName = tfCustomValidation({ 'Last Name': v.target.value }, index, 'required | specialName'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'Last Name', 'required') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="px-4">
      <b-col md="3">
        <BaseEInputText
          :value="item.ssn"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          :name="index + 'ssn'"
          label-content="SSN"
          data-vv-as="SSN"
          mark-required
          :placeholder="placeholders.ssn"
          @blur="(v) => (item.ssn = tfCustomValidation({ 'SSN': v.target.value }, index, 'required | ssn'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'SSN') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel label="Date of Birth" />
        <BaseDate
          v-model="item.dateOfBirth"
          type="date"
          :field-id="item.dateOfBirth"
          :name="index + 'dateOfBirth'"
          data-vv-as="Date of Birth"
          :max="maxbirtdate"
        ></BaseDate>
        <div class="error">
          {{ errors.first(index + 'dateOfBirth') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="item.phoneNumber"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          :name="index + 'phoneNumber'"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :placeholder="placeholders.phoneNumber"
          @blur="(v) => (item.phoneNumber = tfCustomValidation({ 'Phone #': v.target.value }, index, 'phone'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'Phone #') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="px-4">
      <b-col md="3">
        <BaseEInputText
          :value="item.driverLicenseNumber"
          validattor="[A-Za-z0-9]"
          type="text"
          maxlength="20"
          :name="index + 'driverLicenseNumber'"
          label-content="Driver's License Number"
          data-vv-as="Driver's License Number"
          :mark-required="item.driverLicenseState === '' ? false : true"
          :placeholder="placeholders.borrowerDriverLicenseNumber"
          @blur="((v) => (item.driverLicenseNumber = item.driverLicenseState !== '' ?
            tfCustomValidation({ 'Driver License Number': v.target.value }, index, 'required | dlno')
            : tfCustomValidation({ 'Driver License Number': v.target.value }, index, 'dlno')))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'Driver License Number') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel
          :mark-required="item.driverLicenseNumber === '' ? false : true"
          label="Driver's License State"
        />
        <BaseDropdown
          v-model="item.driverLicenseState"
          v-validate="{
            required: validateLicenseState(item.driverLicenseNumber, item.driverLicenseState),
          }"
          data-vv-as="Driver's License State"
          :field-id="item.driverLicenseState"
          :options="states"
          class="mb-1"
          :name="index + 'driverLicenseState'"
          :placeholder="placeholders.borrowerDriverLicenseState"
          @change="validateLicenseNumber(index, item.driverLicenseState)"
        ></BaseDropdown>
        <div class="error">
          {{ errors.first(index + 'driverLicenseState') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="item.creditFile"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Credit File"
          type="text"
          :name="index + 'creditFile'"
          maxlength="20"
          label-content="Credit File"
          :placeholder="placeholders.creditFile"
          @blur="(v) => (item.creditFile = tfCustomValidation({ 'Credit File': v.target.value }, index, 'creditFile'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index, 'Credit File') }}
        </div>
      </b-col>
    </b-row>
    <b-row align-v="center" class="py-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            class="pl-3"
            label="Residential Address"
          />
        </div>
      </b-col>
      <b-col class="border-bottom mr-4"></b-col>
    </b-row>
    <b-row v-if="index > 0">
      <b-col md="12" class="ml-4 my-1">
        <b-form-checkbox
          v-model="item.isResidentialAddress"
          :name="index + 'isResidentialAddress'"
          :disabled="disableCopyBox"
          @change="copyBorrowerAddress(index)"
        >
          Residential Address same as Borrower 1?
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="px-4">
      <b-col md="5">
        <BaseEInputText
          :value="item.residentialStreetAddress"
          :validattor="Validattor.street"
          type="text"
          :name="index + 'residentialStreetAddress'"
          maxlength="100"
          label-content="Street"
          data-vv-as="Street"
          :placeholder="placeholders.streetAddress"
          @blur="(v) => (item.residentialStreetAddress = item.residentialInfoMandatory ? tfCustomValidation({ 'Street Name': v.target.value }, index, 'street')
                                                                                       : item.residentialStreetAddress = tfCustomValidation({ 'Street Name': v.target.value }, index, 'street'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ item.residentialInfoMandatory ? showCustomErrors(index, 'Street Name') : showCustomErrors(index, 'Street Name') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="item.residentialCityName"
          :validattor="Validattor.city"
          type="text"
          :name="index + 'residentialCityName'"
          maxlength="20"
          label-content="City"
          data-vv-as="City Name"
          :placeholder="placeholders.cityName"
          @blur="(v) => (item.residentialCityName = item.residentialInfoMandatory ? tfCustomValidation({ 'City Name #': v.target.value }, index, 'city')
                                                                                  : tfCustomValidation({ 'City Name #': v.target.value }, index, 'city'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ item.residentialInfoMandatory ? showCustomErrors(index, 'City Name #') : showCustomErrors(index, 'City Name #') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel label="State"  />
        <BaseDropdown
          v-model="item.residentialState"
          v-validate="false"
          :field-id="item.residentialState"
          :options="states"
          :name="index + 'residentialState'"
          data-vv-as="State"
          :placeholder="placeholders.state"

        ></BaseDropdown>
        <div class="error">
          {{ errors.first(index + 'residentialState') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          :value="item.residentialZip"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          :name="index + 'residentialZip'"
          label-content="Zip"
          data-vv-as="Zip"
          :placeholder="placeholders.zip"
          @blur="(v) => (item.residentialZip = item.residentialInfoMandatory ? tfCustomValidation({ 'Zip #': v.target.value }, index, 'zip')
                                                                             : tfCustomValidation({ 'Zip #': v.target.value }, index, 'zip'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ item.residentialInfoMandatory ? showCustomErrors(index, 'Zip #', 'required') : showCustomErrors(index, 'Zip #') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="px-4">
      <b-col md="3">
        <BaseELabel label="Ownership Status" />
        <BaseDropdown
          v-model="item.residentialOwnership"
          :options="ownershipLists"
          :name="index + 'residentialOwnership'"

        ></BaseDropdown>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="pb-3" />
    </b-row>
    <div v-if="item.isShowEmployment">
    <div v-for="(emp,k) in item.employerData" :key="k">
    <!-- <b-row align-v="center" class="py-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            class="pl-3"
            label="Employment Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom mr-4"></b-col>
    </b-row> -->
    <b-card-header header-tag="header" class="p-0 mx-3 mt-2 border" role="tab">
      <b-row
        align-v="center"
        class="py-0">
        <b-col :id="`${index}B${k}E`" v-b-toggle="index + 'borrower' + k" class="d-flex" md="11"
               @click="emp.isVisibleEmployer = !emp.isVisibleEmployer">
          <!-- <b-col md="2">
          <div> -->
            <BaseELabel :label="`Employment ${k + 1} Information`" class="ml-2" />
          <!-- </div>
        </b-col> -->
        <strong class="ml-auto pt-1"><i :class="`fa fa-angle-${emp.isVisibleEmployer ? 'up' : 'down'}`"></i></strong>
        </b-col>
        <b-col md="1" class="pl-0">
          <BaseIcon
          v-if="k"
          v-b-tooltip.hover.top="`Remove Employer ${k + 1}`"
          noninteractive
          name="times-circle"
          class="cursor-pointer ml-1"
          @click="onRemoveEmployer(index, k)"
        />
        </b-col>
      </b-row>
    </b-card-header>
    <b-collapse :id="`${index}` + 'borrower' + k"
                visible :accordion="`${index}` + 'borrower' + k" role="tabpanel"
                class="border mx-3">
                <b-row class="px-4">
        <b-col md="3">
        <BaseELabel label="Employment Status"  mark-required/>
        <BaseDropdown
          v-model="emp.employmentStatus"
          show-select-as-option
          :options="getEmploymentOptions(k)"
          :name="index + 'employmentStatus' + k"
          @change="manageEmployer(index, k)"
        ></BaseDropdown>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="emp.employerName"
          validattor="^[A-Za-z0-9.'_#@%&/ -]+$"
          type="text"
          :name="index + 'employerName' + k"
          maxlength="100"
          label-content="Employer Name"
          mark-required
          :is-disabled="emp.disableEmployer"
          :placeholder="placeholders.employerName"
          @blur="(v) => (emp.employerName = tfCustomValidation({ 'Employer Name': v.target.value }, index + `'${k}'`, 'required | company'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index + `'${k}'`, 'Employer Name', 'required') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="emp.employmentPhone"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          :name="index + 'employmentPhone' + k"
          label-content="Phone Number"
        :is-disabled="emp.disableEmployer"
          :placeholder="placeholders.phoneNumber"
          @blur="(v) => (emp.employmentPhone = tfCustomValidation({ 'Phone': v.target.value }, index + `'${k}'`, 'phone'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index + `'${k}'`, 'Phone') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="px-4 pb-3">
      <b-col md="5">
        <BaseEInputText
          :value="emp.employmentStreetAddress"
          :validattor="Validattor.street"
          type="text"
          :name="index + 'employmentStreetAddress' + k"
          maxlength="100"
          label-content="Street"
          :is-disabled="emp.disableEmployer"
          :placeholder="placeholders.streetAddress"
          @blur="(v) => (emp.employmentStreetAddress = tfCustomValidation({ 'Street': v.target.value }, index + `'${k}'`, 'street'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index + `'${k}'`, 'Street') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          :value="emp.employmentCityName"
          :validattor="Validattor.city"
          type="text"
          :name="index + 'employmentCityName' + k"
          maxlength="20"
          label-content="City"
          :is-disabled="emp.disableEmployer"
          :placeholder="placeholders.cityName"
          @blur="(v) => (emp.employmentCityName = tfCustomValidation({ 'City Name': v.target.value }, index + `'${k}'`, 'city'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index + `'${k}'`, 'City Name') }}
        </div>
      </b-col>
  <b-col md="2">
        <BaseELabel label="State" mark-required />
        <BaseDropdown
          :id="index + 'employmentState' + k"
          v-validate="{
            required: emp.disableEmployer ? false : emp.employmentState ? false : true,
          }"
          :value="emp.employmentState"
          data-vv-as="State"
          :field-id="index + 'employmentState' + k"
          :options="states"
          :name="index + 'employmentState' + k"
          :is-disabled="emp.disableEmployer"
          @blur="(v) => (emp.employmentState = tfCustomValidation({ 'State': v.target.value }, index + `'${k}'`, 'required'))"
        ></BaseDropdown>
        <!-- <div class="error">
          {{ errors.first(index + 'employmentState' + k) }}
        </div> -->
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index + `'${k}'`, 'State') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          :value="emp.employmentZip"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          :name="index + 'employmentZip' + k"
          :is-disabled="emp.disableEmployer"
          label-content="Zip"
          :placeholder="placeholders.zip"
          @blur="(v) => (emp.employmentZip = tfCustomValidation({ 'Zip': v.target.value }, index + `'${k}'`, 'zip'))"
        ></BaseEInputText>
        <div v-show="customErrors.length" class="error">
          {{ showCustomErrors(index + `'${k}'`, 'Zip') }}
        </div>
      </b-col>
    </b-row>
    </b-collapse>
    </div>
    <b-row class="pr-3 mt-2 mb-3">
      <b-col>
        <BaseEButton
           class="float-right px-3 py-0"
           variant="icon"
          :disabled="item.employerData.length > employerCountLimit"
          @click="addEmployer(index)"
        >
            Add Employer<BaseIcon name="plus" class="ml-1"> </BaseIcon>
          </BaseEButton>
      </b-col>
    </b-row>
    </div>
    </b-collapse>
    </div>
    </div>
  </div>
</template>

<script>
import customValidation, { customErrors } from '@utils/custom-validator'
import constant from '@constants/constant'
export default {
  inject:['$validator'],
  props : {
    borrowerDetails : {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return  {
      Validattor : {
        name: "^[A-Za-z0-9.' -]+$",
        city: "^[A-Za-z.' -]+$",
        street: "^[A-Za-z0-9.'#@%&/ -]+$",
        specialName:"^[A-Za-z0-9.'#@%/ -]+$"
      },
      maxbirtdate: '',
      ownershipLists: [
        {
          text: 'Rent',
          value: 'Rent',
        },
        { text: 'Own', value: 'Own' },
      ],
      employmentStatusList: constant.FRXEmploymentStatusList,
      customErrors: customErrors,
      employerCountLimit: constant.FRXEmployerInfoLimit, // limit upto 2 employers per borrower
    }
  },
  computed: {
    placeholders() {
      return {
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        cityName: 'City Name',
        state: 'Select State',
        ssn: 'xxx-xx-xxxx',
        zip: 'xxxxx-xxxx',
        streetAddress: 'Street Address',
        phoneNumber: '(xxx) xxx-xxxx',
        driverLicenseNumber: 'Driver License #',
        creditFile: 'credit File',
        borrowerDriverLicenseNumber: 'Driver License Number',
        employerName: 'Employer Name',
      }
    },

    states() {
      return this.$_allStates
    },
    disableCopyBox() {
      let firstBorrower = this.borrowerDetails[0]
      let shouldDisable = firstBorrower.residentialStreetAddress === '' && firstBorrower.residentialCityName === '' &&
             firstBorrower.residentialState === '' && firstBorrower.residentialZip === ''
      if(shouldDisable) {
        this.borrowerDetails.map((x) => {
          x.isResidentialAddress = false
        })
      }
      return shouldDisable
    },
  },
  created() {
    this.customErrors.length = 0
  },
  methods: {
    ...customValidation,
    expandForm() {
      // expand form on submit to show errors if any
      this.borrowerDetails.map((b, ind) => {
        if(!b.isVisibleBorrower) {
          document.getElementById(`${ind}B`).click()
        }
        if(b.employerData.length) {
          b.employerData.map((e, k) => {
            if(!e.isVisibleEmployer) {
              document.getElementById(`${ind}B${k}E`).click()
            }
          })
        }
      })
    },
    onRemoveEmployer(index, n) {
      this.borrowerDetails[index].employerData.splice(n, 1)
      // clear custom validation errors based on the employer data removal.
      var errList=[]
      this.customErrors.map((x,i) => {
       if((["Employer Name","Street","City Name","Zip","State"].includes(x.field) && x.row === String(String(`${index}`) + `'` + String(`${n}`)+ `'`))
          || (x.row === String(String(`${index}`) + `'` + String(`${n+1}`)+ `'`))){
            errList.push(i)
          }
      })
      while(errList.length) {
        this.customErrors.splice(errList.pop(), 1)
      }
    },
    getEmploymentOptions(n) {
      // render employment options as per the nth employer to be added.
      return (n > 0) ? this.employmentStatusList.slice(0,2) : this.employmentStatusList
    },
    copyBorrowerAddress(index) {
      if(this.borrowerDetails[index].isResidentialAddress) {
        let firstBorrower = this.borrowerDetails[0]
        this.borrowerDetails[index].residentialStreetAddress = firstBorrower.residentialStreetAddress
        this.borrowerDetails[index].residentialCityName = firstBorrower.residentialCityName
        this.borrowerDetails[index].residentialState = firstBorrower.residentialState
        this.borrowerDetails[index].residentialZip = firstBorrower.residentialZip
        this.tfCustomValidation({ 'Street Name': this.borrowerDetails[index].residentialStreetAddress }, index, 'street' )
        this.tfCustomValidation({ 'City Name #': this.borrowerDetails[index].residentialCityName }, index, 'city' )
        this.tfCustomValidation({ 'Zip #': this.borrowerDetails[index].residentialZip }, index, 'zip' )
      }
      else {
        this.borrowerDetails[index].residentialStreetAddress = ''
        this.borrowerDetails[index].residentialCityName = ''
        this.borrowerDetails[index].residentialState = ''
        this.borrowerDetails[index].residentialZip = ''
      }
    },
    manageEmployer(index, k){
      if(["Other Income","Unemployed"].includes(this.borrowerDetails[index].employerData[k].employmentStatus)){
       this.borrowerDetails[index].employerData[k].disableEmployer= true
       this.borrowerDetails[index].employerData[k].employerName=''
       this.borrowerDetails[index].employerData[k].employmentPhone=''
       this.borrowerDetails[index].employerData[k].employmentStreetAddress=''
       this.borrowerDetails[index].employerData[k].employmentCityName=''
       this.borrowerDetails[index].employerData[k].employmentState=''
       this.borrowerDetails[index].employerData[k].employmentZip=''
       var array=[]
       this.customErrors.map((x,i)=>{
       if((["Employer Name","Street","City Name","Zip","State"].includes(x.field)) && x.row === String(String(`${index}`) + `'` + String(`${k}`)+ `'`)){
        array.push(i)
       }
       })
       while(array.length) {
    this.customErrors.splice(array.pop(), 1);
     }
      }else{
        this.borrowerDetails[index].employerData[k].disableEmployer= false
      }

    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    showName(item) {
      return item.firstName || item.middleName || item.lastName
    },
    onRemoveBorrower(index) {
      this.borrowerDetails.splice(index, 1)
        while(this.customErrors.length) {
          this.customErrors.splice(this.customErrors.findIndex(x => x.row === index), 1)
        }
    },
    validateLicenseNumber(index, value) {
      if(value === '' && this.customErrors.length) {
        this.customErrors.splice(this.customErrors.findIndex(x => x.row === index && x.field === 'Driver License Number'), 1)
      }
    },
    validateLicenseState(number, state) {
      if(number) {
        if(state) { return false } return true
      }
      return false
    },
    validateResidentialState(mandatory, value) {
      if(mandatory &&  value !== '') {
        return false
      } else if(!mandatory) {
        return false
      } else return true
    },
    addEmployer(index) {
      this.borrowerDetails[index].employerData.push({
          employerName: '',
          employmentPhone: '',
          employmentStatus: 'Currently Employed',
          employmentStreetAddress: '',
          employmentCityName: '',
          employmentState: '',
          employmentZip: '',
          disableEmployer: false,
          isVisibleEmployer: true,
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@design';

.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
